import { Link, useLocation } from 'react-router-dom';
import { useAuth } from 'zite-auth-sdk';
import { Home, BookOpen, User, Bell, CalendarDays } from 'lucide-react';
import { useFeatureToggles } from './FeatureToggleProvider';

export default function MobileBottomNav() {
  const { user } = useAuth();
  const location = useLocation();
  const { isRouteEnabled } = useFeatureToggles();

  const allItems = [
    { label: 'Home', icon: Home, href: '/' },
    { label: 'Training', icon: BookOpen, href: '/train' },
    { label: 'Leave', icon: CalendarDays, href: '/leave' },
    { label: 'Alerts', icon: Bell, href: '/notifications' },
    { label: 'Profile', icon: User, href: '/profile' },
  ];

  const items = allItems.filter(i => isRouteEnabled(i.href));

  const isActive = (href: string) =>
    href === '/' ? location.pathname === '/' : location.pathname.startsWith(href);

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border shadow-lg safe-area-bottom">
      <div className="flex items-stretch justify-around h-14">
        {items.map(item => {
          const active = isActive(item.href);
          const Icon = item.icon;
          return (
            <Link
              key={item.href}
              to={item.href}
              className={`flex flex-col items-center justify-center flex-1 gap-0.5 no-underline transition-colors min-w-0 relative ${
                active ? 'text-primary' : 'text-muted-foreground'
              }`}
            >
              <Icon className={`w-5 h-5 ${active ? 'text-primary' : ''}`} />
              <span className={`text-[10px] leading-tight truncate ${active ? 'font-semibold' : 'font-medium'}`}>
                {item.label}
              </span>
              {active && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-primary rounded-full" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
